import { REPLAY_CONFIG } from "@/config/replay";

export default function ReplayFooter() {
  const cfg = REPLAY_CONFIG;
  return (
    <footer className="relative overflow-hidden border-t wam-hairline pt-24 pb-10" data-testid="replay-footer">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div
          aria-hidden
          className="wam-deboss select-none pointer-events-none leading-[0.75] whitespace-nowrap"
          style={{ fontSize: "14vw" }}
        >
          SMALL BUSINESS AUTOMATOR
        </div>

        {cfg.APPROVED_COMPLIANCE_COPY && (
          <div className="mt-16 border-t wam-hairline pt-8 font-body text-[12px] leading-[1.75] text-[#F0ECE4]/45 max-w-[900px] whitespace-pre-line" data-testid="replay-compliance">
            {cfg.APPROVED_COMPLIANCE_COPY}
          </div>
        )}

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6 border-t wam-hairline pt-8 font-mono text-[10px] tracking-[0.24em] text-[#F0ECE4]/45">
          <div>
            <div className="text-[#C9A84C] mb-2">SMALL BUSINESS AUTOMATOR</div>
            <a
              href="mailto:dallas@smallbusinessautomator.com"
              className="hover:text-[#F0ECE4] transition-colors"
            >
              dallas@smallbusinessautomator.com
            </a>
          </div>
          <div className="flex flex-wrap gap-4 md:justify-center">
            <a href="/privacy" className="hover:text-[#F0ECE4] transition-colors">PRIVACY POLICY</a>
            <span className="text-[#F0ECE4]/20">·</span>
            <a href="/terms" className="hover:text-[#F0ECE4] transition-colors">TERMS</a>
          </div>
          <div className="md:text-right">
            © 2026 SMALL BUSINESS AUTOMATOR. ALL RIGHTS RESERVED.
          </div>
        </div>
      </div>
    </footer>
  );
}
